var map = {
	"./avatar_die.wav": 6883,
	"./blast.wav": 7671,
	"./boost_off.wav": 7390,
	"./boost_on.wav": 6220,
	"./booster_claim_idle.wav": 4337,
	"./booster_claim_version1.wav": 1562,
	"./booster_claim_version2.wav": 3157,
	"./boulder_jump.wav": 1281,
	"./boulder_lvl_fall.wav": 7707,
	"./cores.wav": 8333,
	"./ending_window.wav": 9601,
	"./new_record.wav": 437,
	"./notification_in.wav": 4848,
	"./secret_door.wav": 4054,
	"./shield_in.wav": 4790,
	"./shield_out.wav": 2125,
	"./shockwave_blast.wav": 1599,
	"./splash.wav": 4702,
	"./trap2_spear.wav": 8150,
	"./trap3_platform_land.wav": 2163,
	"./trap4_moving_spikes_loop.wav": 1620,
	"./trap5_axe360.wav": 2215,
	"./trap6_axe180.wav": 6530,
	"./trap7_spear_box.wav": 8677,
	"./trap8_rotating_box.wav": 3427,
	"./traps_fade.wav": 1722,
	"./turn_to_day.wav": 4081,
	"./turn_to_night.wav": 4797,
	"./ui_general_rock_button.wav": 8463
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9213;